import api from "./api";

export const getMyVenueDetail = async () => {
  return api
    .get({
      endpoint: "/own/my-venue",
      port: process.env.REACT_APP_PORT_VENUE,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
